import produce from "immer";
import React, { FC } from "react";
import { useDispatch } from "react-redux";
import { startEditElement } from "../../../../actions/elementListAction";
import { Element } from "../../../../models/elementModel";
import { TabelCell } from "../../../../models/tabelCellModel";
import Switch from "react-switch";

export interface CellItemPropertiesProps {
  element: Element;
  cell: TabelCell;
  rowIndex: number;
  cellIndex: number;
}

const CellItemProperties: FC<CellItemPropertiesProps> = ({
  element,
  cell,
  rowIndex,
  cellIndex,
}) => {
  const dispatch = useDispatch();
  return (
    <div className="card border-0">
      <div className="" id={`cellHeading-${cell.id}`}>
        <h5 className="mb-0">
          <button
            className="btn btn-dark btn-block theam-component theam-font border-radius-0 collapsed"
            data-toggle="collapse"
            data-target={`#Cell-heading-content-${cell.id}`}
            aria-expanded="false"
            aria-controls={`Cell-heading-content-${cell.id}`}
          >
            {`Cell ${cellIndex + 1}`}
          </button>
        </h5>
      </div>
      <div
        id={`Cell-heading-content-${cell.id}`}
        className="collapse"
        aria-labelledby={`cellHeading-${cell.id}`}
      >
        <div className="card-body theam-card">
          <div className="form-group row">
            <label
              htmlFor="cell-theme"
              className="col-sm-3 col-form-label font-size-12 remove-left-right-padding align-text-left"
            >
              Theme
            </label>
            <div className="col-sm-8">
              <select
                value={element.properties.rows[rowIndex].cells[cellIndex].class}
                id="cell-theme"
                className="form-control theam-textbox"
                onChange={(e) => {
                  const newElement = produce(element, (draft) => {
                    draft.properties.rows[rowIndex].cells[cellIndex].class =
                      e.target.value;
                  });
                  dispatch(startEditElement(newElement));
                }}
              >
                <option value={""}>--Select--</option>
                <option value={"table-primary"}>Cell Primary</option>
                <option value={"table-secondary"}>Cell Secodry</option>
                <option value={"table-success"}>Cell Success</option>
                <option value={"table-danger"}>Cell Danger</option>
                <option value={"table-warning"}>Cell Warning</option>
                <option value={"table-info"}>Cell Info</option>
                <option value={"table-light"}>Cell Light</option>
                <option value={"table-dark"}>Cell Dark</option>
              </select>
            </div>
          </div>
        <div className="form-group row">
          <label
            htmlFor="width"
            className="col-sm-3 col-form-label font-size-12 remove-left-right-padding align-text-left"
          >
            Width
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              className="form-control theam-textbox"
              id="width"
              value={
                element.properties.rows[rowIndex].cells[cellIndex].properties
                  .width
              }
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.rows[rowIndex].cells[
                    cellIndex
                  ].properties.width = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
            />
          </div>
          <div className="col-sm-1 col-form-label font-size-12 remove-left-right-padding text-align-justify">
            <span>px</span>
          </div>
          </div>
          <div className="form-group row">
          <label
            htmlFor="height"
            className="col-sm-3 col-form-label font-size-12 remove-left-right-padding align-text-left"
          >
            Height
          </label>
          <div className="col-sm-8">
            <input
              type="number"
              className="form-control theam-textbox"
              id="height"
              value={
                element.properties.rows[rowIndex].cells[cellIndex].properties
                  .height
              }
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.rows[rowIndex].cells[
                    cellIndex
                  ].properties.height = e.target.value;
                });
                dispatch(startEditElement(newElement));
              }}
            />
          </div>
          <div className="col-sm-1 col-form-label font-size-12 remove-left-right-padding text-align-justify">
            <span>px</span>
          </div>
        </div>
        <div className="form-group row">
          <label
            htmlFor="displayInline"
            className="col-sm-3 col-form-label font-size-12 remove-left-right-padding align-text-left"
          >
            Inline
          </label>
          <div className="col-sm-4 text-align-justify">
            <Switch
              checked={
                element.properties.rows[rowIndex].cells[cellIndex].properties
                  .displayInline
              }
              className="react-switch"
              id="displayInline"
              onColor="#86d3ff"
              onHandleColor="#2693e6"
              handleDiameter={15}
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
              activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
              height={10}
              width={24}
              onChange={(e) => {
                const newElement = produce(element, (draft) => {
                  draft.properties.rows[rowIndex].cells[
                    cellIndex
                  ].properties.displayInline = e;
                });
                dispatch(startEditElement(newElement));
              }}
            />
          </div>
        </div>
        </div>
      </div>
    </div>
  );
};

export default CellItemProperties;
